import * as ApiFunctionCalls from '@/utils/ApiFunctionCalls';
import moment from 'moment';
var tokenData;
var timeTofech = 4;
try {
  if (localStorage.getItem('authUser')) {
    tokenData = JSON.parse(atob(localStorage.getItem('authUser')));
  } else {
    tokenData = [];
  }
} catch (error) {
  console.log(error);
}

var wegHasAccess;
try {
  if (localStorage.getItem('weg-portal')) {
    wegHasAccess = JSON.parse(localStorage.getItem('weg-portal'));
  } else {
    wegHasAccess = null;
  }
} catch (error) {
  console.log(error);
}

const state = {
  loggedWithAzure: false,
  azureUser: false,
  AppLoaded: false,
  emailVerifyData: [],
  ActivitiesData: [],
  AllTransactions: [],
  AllInvoices: [],
  AllOrdesData: [], // storing all orders
  ApiPage: [],
  archivedOrders: [], // storying oders that are older than 30 days
  archivedTasks: [],
  Announcments: [],
  Banners: [],
  CheckLists: [],
  checkListsDetails: [],
  CommLog: [],
  CommLogData: [],
  CompanyDetails: [], // About Us page
  clientTokenData: [],
  Employees: [], // About Us page
  evaluationReports: [],
  evaluationReportSpecs: [],
  EvaluationScore: null,
  Evaluations: null,
  EvaluationFiles: [],
  Files: [],
  FranchiseStores: [],
  allStores: { data: [] },
  registeredData: [],
  allJobPositions: [],
  formatedPorjectsData: [],
  hostname:
    process.env.NODE_ENV === 'development'
      ? 'dev.gregorys.gr' //  ? 'ops.gregorys.gr'
      : window.location.hostname,
  informationMaterial: { files: [] },
  knowledgeBase: [],
  meetingData: [],
  maintenance: [],
  ordersData: [], // storying latest orders, the orders that are at least 30days old
  OrderDetailsId: [], // id or the order we want to get the details
  OrderDetails: [], // all details for a specific order, based on the id we have stored above

  Pages: [],
  projectsData: [],
  PaidInvoices: [],
  Posts: [],
  PostsWidget: {},
  FAQPosts: [],
  PostFiles: [],
  PostCats: [],
  StoreMenu: {},
  SumOrders: [], // sum all pending orders
  SumTasks: [], // sum all pending tasks
  Subscriptions: [],
  Sidebar: [],
  Staff: null,
  selectedLocation: null,
  selectedLocationInfo: {},
  selectedWarehouse: null,

  // masterTokenData: JSON.parse(atob(localStorage.getItem('authBUser'))),
  tokenData: tokenData,
  TicketFiles: [],
  Translations: [],
  TraineeTraining: [],
  TraineeTrainingArchive: [],
  TraineeTrainingMaterial: [],
  todos: [], // calendar days

  ticketTypes: [],
  TicketDetailsId: [], // id for the ticket we want to get details
  TicketDetails: [], // details for a specific ticket based on the id we have stored above
  TicketThreads: [],
  trainingNotes: [],
  trainingNotesFiles: [],
  TrainingVideos: [],
  tasksData: [],

  UserData: [],
  userRole: false,
  Licenses: [],
  LogData: [],

  UnpaidInvoices: [],

  Users: [],

  Warehouse: [],
  ContractorsFile: {},
  LocationExceptionsFiles: [],
  ImmediateCoverageProductsFile: {},
  Weg: wegHasAccess,
  WidgetsTotal: []
};
// ---------------------------------------------MUTATIONS -----------------------------------------------------------------
const mutations = {
  // setTokenData (state, data) {
  //   state.tokenData = data
  // },
  setAppLoaded(state, data) {
    state.AppLoaded = data;
  },
  setBanners(state, data) {
    state.Banners = data;
  },
  setUserData(state, data) {
    // console.log(state.allStores);
    // if (
    //   data.type === 2 &&
    //   (data.job_position_id === 1 || data.job_position2_id === 1)
    // ) {
    //   data.user_type = 'Franchise';
    //   state.userRole = 'franchisee';
    // } else {
    //   let isStoreManager =
    //     state.allStores.data.filter(store => data.id === store.manager_id)
    //       .length > 0;
    //   if (isStoreManager) {
    //     data.user_type = 'StoreManager';
    //     state.userRole = 'store_manager';
    //   // else if (data.type === 23) {
    //   //   data.user_type = 'Franchise';
    //   //   state.userRole = 'franchisee';
    //   // }
    //   } else if (data.type === 2) {
    //     if (data.is_trainee) {
    //       data.user_type = 'Trainee';
    //       state.userRole = 'trainee';
    //     } else if (data.locations.length > 0) {
    //       data.user_type = 'Staff';
    //       state.userRole = 'user';
    //     } else {
    //       if (state.azureUser) {
    //         data.user_type = 'Staff';
    //         state.userRole = 'azureUser';
    //       }
    //     }
    //   } else {
    //     if (state.azureUser) {
    //       data.user_type = 'Staff';
    //       state.userRole = 'azureUser';
    //     }
    //   }
    // }
    data.user_type = data.portal_user_type;
    state.userRole = data.portal_user_role;
    state.UserData = data;
    // console.log(state.userRole);
    // console.log(data.user_type);
  },
  setProjectsData(state, data) {
    state.projectsData = data;
  },
  setWidgetsTotal(state, data) {
    state.WidgetsTotal = data;
  },
  setPosts(state, data) {
    state.Posts = data;

    let postsWidget = [];
    let postFeatured = [];
    let currentData = {};
    data
      .filter(post => {
        if (post.from_stamp && post.archive_in_days) {
          return (
            moment.duration(moment().diff(moment(post.from_stamp))).asDays() <
            post.archive_in_days
          );
        } else if (post.archive_in_days) {
          return (
            moment.duration(moment().diff(moment(post.c_stamp))).asDays() <
            post.archive_in_days
          );
        } else if (post.from_stamp && post.to_stamp) {
          return moment().isBetween(
            moment(post.from_stamp),
            moment(post.to_stamp)
          );
        } else if (post.from_stamp && !post.to_stamp) {
          return (
            moment.duration(moment().diff(moment(post.from_stamp))).asDays() > 0
          );
        } else {
          return true;
        }
      })
      .map(post => {
        // console.log('POST:', post);
        if (post.featured && postFeatured.length < 3) {
          // console.log(post);
          currentData = {
            id: post.id,
            title: post.title,
            description: post.description,
            subtitle: post.subtitle,
            stamp: post.from_stamp
              ? moment(post.from_stamp).format('DD/MM/YYYY')
              : moment(post.c_stamp).format('DD/MM/YYYY'),
            featured: post.featured
          };
          postFeatured.push(currentData);
        } else if (!post.featured && postsWidget.length < 5) {
          currentData = {
            id: post.id,
            title: post.title,
            subtitle: post.subtitle,
            description: post.description,
            stamp: post.from_stamp
              ? moment(post.from_stamp).format('DD/MM/YYYY')
              : moment(post.c_stamp).format('DD/MM/YYYY'),
            featured: post.featured
          };
          postsWidget.push(currentData);
        } else {
          /* eslint-disable */
          return;
          /* eslint-disable */
        }
      });

    const posts = [...postFeatured, ...postsWidget];
    const headers = ['title', 'subtitle', 'stamp'];

    state.PostsWidget = { posts: posts, headers: headers };
  },
  setFAQPosts(state, data) {
    state.FAQPosts = data;
  },
  setTasksData(state, data) {
    state.tasksData = data;
  },
  setTrainingNotes(state, data) {
    state.trainingNotes = data;
  },
  setEvaluationReports(sate, data) {
    state.evaluationReports = data;
  },
  SET_EVAL_FILES(sate, data) {
    state.EvaluationFiles = data;
  },
  setEvaluationReportSpecs(sate, data) {
    state.evaluationReportSpecs = data;
  },
  setEvaluationScore(sate, data) {
    state.EvaluationScore = data;
  },
  setEvaluations(sate, data) {
    state.Evaluations = data;
  },
  setTraineeTraining(state, data) {
    state.TraineeTraining = data;
  },
  setTraineeTrainingArchive(state, data) {
    state.TraineeTrainingArchive = data;
  },
  setTrainingNotesFiles(state, data) {
    state.trainingNotesFiles = data;
  },
  setTrainingVideos(state, data) {
    state.TrainingVideos = data;
  },
  setTraineeTrainingMaterial(state, data) {
    state.TraineeTrainingMaterial = data;
  },
  SetStoreMenu(state, data) {
    state.StoreMenu = data;
  },
  setSumTasks(state, data) {
    state.SumTasks = data;
  },
  setStaff(state, data) {
    state.Staff = data;
  },
  setAllOrdersData(state, data) {
    state.AllOrdesData = data;
    state.AllOrdesData.timestamp = moment();
  },
  setOrdersData(state, data) {
    state.ordersData = data;
  },
  setArchivedOrders(state, data) {
    state.archivedOrders = data;
  },
  SetOrderDetails(state, data) {
    state.OrderDetails = data;
  },
  setSumOrders(state, data) {
    state.SumOrders = data;
  },
  setMaintenance(state, data) {
    state.maintenance = data;
  },
  setMeetingData(state, data) {
    state.meetingData = data;
  },
  updateTaskList(state, data) {
    state.formatedPorjectsData = data;
  },
  updateTasksData(state, data) {
    state.tasksData.push(data);
  },
  fileterProjectTaks(state, data) {
    for (let i = 0; i < state.formatedPorjectsData.length; i++) {
      if (state.formatedPorjectsData[i].id === data[0].project_id) {
        state.formatedPorjectsData[i].tasks = data;
      }
    }
  },
  addNewTask(state, data) {
    state.formatedPorjectsData.map(project => {
      if (project.id === parseInt(data.project_id)) {
        project.tasks.push(data);
        // alert(data.Assignee)
      }
    });
    // console.log(state.formatedPorjectsData)
  },
  // addToArchive (state, data) {
  //   state.archivedTasks.map(archive => {
  //     archive.Assignee = data.contact_name
  //     archive.Complete = data.
  //     archive.Project =
  //     archive.Task = data.title
  //   })
  //   console.log(data)
  //   console.log(state.archivedTasks)
  // },
  setTodos(state, data) {
    state.todos = data;
  },
  setArchivedTasks(state, data) {
    state.archivedTasks = data;
  },
  SetCommLog(state, data) {
    state.CommLog = data;
    // state.CommLog.total = data.length
  },
  SetCommLogData(state, data) {
    state.CommLogData = data;
  },
  SetLicenses(state, data) {
    state.Licenses = data;
  },
  SetLogData(state, data) {
    state.LogData = data;
  },
  SetKnowledgebaseUserNotes(state, data) {
    state.knowledgeBase = data;
  },
  SetActivities(state, data) {
    state.ActivitiesData = data;
  },
  SetAllTransactionsData(state, data) {
    state.AllTransactions = data;
  },
  setInformationMaterialApi(state, data) {
    state.informationMaterial = data;
  },
  SetInvoices(state, data) {
    state.AllInvoices = data;
    state.AllInvoices.timestamp = moment();
  },
  SetPaidInvoices(state, data) {
    state.PaidInvoices = data;
  },
  SetUnpaidInvoices(state, data) {
    state.UnpaidInvoices = data;
  },
  changeUser(state, data) {
    state.tokenData = data;
  },
  SetAnnouncments(state, data) {
    state.Announcments = data;
  },
  SetTranslations(state, data) {
    state.Translations = data;
  },
  SetPages(state, data) {
    state.Pages = data;
  },
  SetEmployees(state, data) {
    state.Employees = data;
  },
  SetSubscriptions(state, data) {
    state.Subscriptions = data;
  },
  SetSidebar(state, data) {
    state.Sidebar = data;
  },
  SetCompanyDetails(state, data) {
    state.CompanyDetails = data;
  },
  SetUsers(state, data) {
    state.Users = data;
  },
  SetFiles(state, data) {
    state.Files = data;
  },
  setPostFiles(state, data) {
    state.PostFiles = data;
  },
  SET_POSTS_CATS(state, data) {
    state.PostCats = data;
  },
  SET_ALL_STORES(state, data) {
    state.allStores = data;
  },
  SET_REGISTERED_DATA(state, data) {
    state.registeredData = data;
  },
  SET_EMAIL_VERIFY(state, data) {
    state.emailVerifyData = data;
  },
  SET_ALL_JOB_POSITIONS(state, data) {
    state.allJobPositions = data;
  },
  SetFranchiseStores(state, data) {
    state.FranchiseStores = data;
  },
  SetTicketFiles(state, data) {
    state.TicketFiles = data;
  },
  SET_SELECTED_LOCATION(state, data) {
    state.selectedLocation = data;
  },
  SET_SELECTED_LOCATION_INFO(state, data) {
    state.selectedLocationInfo = data;
  },
  SET_SELECTED_WAREHOUSE(state, data) {
    state.selectedWarehouse = data;
  },
  SET_WEG_EXISTS(state, data) {
    state.Weg = data;
  },
  SET_AZURE_USER(state, data) {
    state.azureUser = data;
  },
  SET_CHECKLISTS(state, data) {
    state.CheckLists = data;
  },
  SET_CHECKLIST_DETAILS(state, data) {
    state.checkListsDetails = data;
  },
  SET_MICROSOFT_LOGIN(state, data) {
    state.loggedWithAzure = data;
  },
  SET_CONTRACTORS_FILE(state, data) {
    state.ContractorsFile = data;
  },
  SET_LOCATION_EXCEPTIONS_FILES(state, data) {
    state.LocationExceptionsFiles = data;
  },
  SET_IMMEDIATE_COVERAGE_PRODUCTS_FILE(state, data) {
    state.ImmediateCoverageProductsFile = data;
  }
};
// ---------------------------------- ACTIONS -----------------------------------------------------------------
const actions = {
  // baseLoad is called on page refresh and on app first
  async BaseLoad({ commit, state }) {
    try {
      let baseData = await ApiFunctionCalls.BaseLoad();

      baseData.franchiseStores && baseData.franchiseStores.length
        ? commit('SetFranchiseStores', baseData.franchiseStores)
        : '';
      //  setting as selected location the first record, if selected location is null
      if (
        state.selectedLocation === null &&
        baseData.franchiseStores &&
        baseData.franchiseStores.length
      ) {
        commit('SET_SELECTED_LOCATION', baseData.franchiseStores[0].id);
        commit(
          'SET_SELECTED_WAREHOUSE',
          baseData.franchiseStores[0].warehouse_id
        );
      }
      baseData.azureUser ? commit('SET_AZURE_USER', baseData.azureUser) : '';
      baseData.license && baseData.license.length
        ? commit('SetLicenses', baseData.license)
        : '';
      baseData.maintenance && baseData.maintenance.length
        ? commit('setMaintenance', baseData.maintenance)
        : '';
      baseData.staff && baseData.staff.length
        ? commit('setStaff', baseData.staff)
        : '';
      baseData.storeMenu && baseData.storeMenu.length
        ? commit('SetStoreMenu', baseData.storeMenu)
        : '';
      baseData.translations
        ? commit('SetTranslations', baseData.translations)
        : '';
      baseData.averageScore
        ? commit('setEvaluationScore', baseData.averageScore)
        : '';
      baseData.knowledgeBaseNotes && baseData.knowledgeBaseNotes.length
        ? commit('SetKnowledgebaseUserNotes', baseData.knowledgeBaseNotes)
        : '';
      baseData.tasks && baseData.tasks.length
        ? commit('setTasksData', baseData.tasks)
        : '';
      // if (baseData.tickets && baseData.tickets.length) {
      //   try {
      //     commit('SetAllTickets', baseData.tickets);
      //   } catch (error) {
      //     console.log(error);
      //   }
      //   try {
      //     commit(
      //       'SetArchivedTickets',
      //       await ApiFunctionCalls.getFilteredTickets(
      //         state.AllTickets,
      //         'resolved'
      //       )
      //     );
      //   } catch (error) {
      //     console.log(error);
      //   }
      //   try {
      //     commit(
      //       'SetTickets',
      //       await ApiFunctionCalls.getFilteredTickets(
      //         state.AllTickets,
      //         'unresolved'
      //       )
      //     );
      //   } catch (error) {
      //     console.log(error);
      //   }
      // }
    } catch (error) {
      console.log(error);
    }
  },
  async userRequest({ commit, state }) {
    try {
      commit('setUserData', await ApiFunctionCalls.getUserData());
    } catch (error) {
      console.log(error);
    }
  },
  async getProjectsData({ commit, state }) {
    commit('setProjectsData', await ApiFunctionCalls.getProjectsData());
  },
  async getPosts({ commit, state }, locationID) {
    commit('setPosts', await ApiFunctionCalls.getPosts(locationID));
  },
  async getWidgetsTotal({ commit, state }) {
    let location_ids = state.FranchiseStores.map(store => store.id);
    commit(
      'setWidgetsTotal',
      await ApiFunctionCalls.getWidgetsTotal(location_ids)
    );
  },
  async getFAQPosts({ commit, state }) {
    commit('setFAQPosts', await ApiFunctionCalls.getFAQPosts());
  },
  async getTasksData({ commit, state }, locationID) {
    commit('setTasksData', await ApiFunctionCalls.getTasksData(locationID));
  },
  async getStoreMenu({ commit, state }) {
    try {
      commit('SetStoreMenu', await ApiFunctionCalls.getStoreMenu());
    } catch (error) {
      console.log(error);
    }
  },
  async getSumTasks({ commit, state }) {
    try {
      commit(
        'setSumTasks',
        ApiFunctionCalls.getDataLength(await ApiFunctionCalls.getTasksData())
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getStaff({ commit, state }) {
    try {
      commit('setStaff', await ApiFunctionCalls.getStaff());
    } catch (error) {
      console.log(error);
    }
  },
  async getFranchiseStores({ commit, state }) {
    try {
      if (state.userRole === 'franchisee') {
        //if (state.UserData.type === 23) {
        let data = await ApiFunctionCalls.getFranchiseStores();
        commit('SetFranchiseStores', data);
        //  setting as selected location the first record, if selected location is null
        if (state.selectedLocation === null) {
          commit('SET_SELECTED_LOCATION', data[0].id);
          commit('SET_SELECTED_WAREHOUSE', data[0].warehouse_id);
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getAllStores({ commit, state }) {
    try {
      let data = await ApiFunctionCalls.getAllStores();
      commit('SET_ALL_STORES', data);
    } catch (error) {
      console.log(error);
    }
  },
  async getRegisteredData({ commit, state }, hash) {
    try {
      let data = await ApiFunctionCalls.getRegisteredData(hash);
      commit('SET_REGISTERED_DATA', data);
    } catch (error) {
      console.log(error);
    }
  },
  async getEmailVerify({ commit, state }, hash) {
    try {
      let data = await ApiFunctionCalls.getEmailVerify(hash);
      commit('SET_EMAIL_VERIFY', data);
    } catch (error) {
      console.log(error);
    }
  },
  async getAllJobPositions({ commit, state }) {
    try {
      let data = await ApiFunctionCalls.getAllJobPositions();
      commit('SET_ALL_JOB_POSITIONS', data);
    } catch (error) {
      console.log(error);
    }
  },
  async getFormatedProjects({ commit, state }) {
    let projects = [];
    if (state.tasksData.length === 0 || state.projectsData.length === 0) {
      projects = ApiFunctionCalls.formatProjects(
        await ApiFunctionCalls.getProjectsData(),
        await ApiFunctionCalls.getTasksData()
      );
    } else {
      projects = ApiFunctionCalls.formatProjects(
        state.projectsData,
        state.tasksData
      );
    }
    commit('updateTaskList', projects);
  },
  async getMaintenance({ commit, state }) {
    try {
      if (
        state.userRole === 'franchisee' ||
        state.userRole === 'store_manager'
      ) {
        //if (state.UserData.type === 23) {
        commit('setMaintenance', await ApiFunctionCalls.getMaintenance());
      }
    } catch (error) {
      console.log('getMaintenance', error);
    }
  },
  async getMeetingData({ commit, state }) {
    try {
      // let dt = await getMeetingData()
      commit('setMeetingData', await ApiFunctionCalls.getMeetingData());
    } catch (error) {
      console.log('setMeetingData: ' + error);
    }
  },
  async getCalendarDates({ commit, state }) {
    try {
      // let dt = await getMeetingData()
      commit(
        'setTodos',
        await ApiFunctionCalls.getCalendarTodos(
          await ApiFunctionCalls.getMeetingDataStartOfYear()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async getCheckLists({ commit, state }, location) {
    try {
      // let dt = await getMeetingData()
      commit('SET_CHECKLISTS', await ApiFunctionCalls.getCheckLists(location));
    } catch (error) {
      console.log(error);
    }
  },

  async getChecklistDetails({ commit, state }, reportID) {
    try {
      // let dt = await getMeetingData()
      commit(
        'SET_CHECKLIST_DETAILS',
        await ApiFunctionCalls.getChecklistDetails(reportID)
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getAllOrdersData({ commit, state }) {
    if (
      state.AllOrdesData.timestamp &&
      moment().diff(state.AllOrdesData.timestamp, 'minutes') < timeTofech
    ) {
    } else {
      try {
        commit('setAllOrdersData', await ApiFunctionCalls.getOrders());
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'setOrdersData',
          await ApiFunctionCalls.getLatestOrders(state.AllOrdesData)
        );
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'setArchivedOrders',
          await ApiFunctionCalls.getArchivedOrders(state.AllOrdesData)
        );
      } catch (error) {
        console.log(error);
      }
      // console.log('Get All Orders');
    }
  },
  async getBanners({ commit, state }) {
    try {
      commit('setBanners', await ApiFunctionCalls.getBanners());
    } catch (error) {
      console.log(error);
    }
  },
  async getOrderDetails({ commit, state }) {
    try {
      commit(
        'SetOrderDetails',
        await ApiFunctionCalls.getOrderDetails(
          state.OrderDetailsId,
          state.AllOrdesData
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getSumOrders({ commit, state }) {
    try {
      commit(
        'setSumOrders',
        await ApiFunctionCalls.getDataLength(await ApiFunctionCalls.getOrders())
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getArchivedTasks({ commit, state }) {
    try {
      commit(
        'setArchivedTasks',
        await ApiFunctionCalls.filterArchivedTasks(
          await ApiFunctionCalls.getTasksData(),
          await ApiFunctionCalls.getProjectsData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getCommLogData({ commit, state }) {
    try {
      commit(
        'SetCommLog',
        await ApiFunctionCalls.getFilteredCommLogData(
          await ApiFunctionCalls.getCommLogData(),
          'resolved'
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getCommLog({ commit, state }) {
    try {
      commit('SetCommLogData', await ApiFunctionCalls.getCommLogData());
    } catch (error) {
      console.log(error);
    }
  },
  async getLicenses({ commit, state }) {
    try {
      if (
        state.userRole === 'franchisee' ||
        state.userRole === 'store_manager'
      ) {
        //if (state.UserData.type === 23) {
        commit('SetLicenses', await ApiFunctionCalls.getLicenses());
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getLogData({ commit, state }) {
    try {
      commit('SetLogData', await ApiFunctionCalls.getLogData());
    } catch (error) {
      console.log(error);
    }
  },
  async getKnowledgebaseUserNotes({ commit, state }) {
    try {
      commit(
        'SetKnowledgebaseUserNotes',
        await ApiFunctionCalls.getKnowledgebaseUserNotes()
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getActiviesData({ commit, state }) {
    try {
      commit(
        'SetActivities',
        await ApiFunctionCalls.formatActivities(
          await ApiFunctionCalls.getActivityData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getAllTransactionsData({ commit, state }) {
    try {
      commit(
        'SetAllTransactionsData',
        await ApiFunctionCalls.formatAllTransactionsData(
          await ApiFunctionCalls.getAllTransactionsData()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getInformationMaterial({ commit, state }, folderID) {
    try {
      commit(
        'setInformationMaterialApi',
        await ApiFunctionCalls.getInformationMaterial(folderID)
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getInvoices({ commit, state }) {
    if (
      state.AllInvoices.timestamp &&
      moment().diff(state.AllInvoices.timestamp, 'minutes') < timeTofech
    ) {
    } else {
      try {
        commit('SetInvoices', await ApiFunctionCalls.getInvoices());
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'SetUnpaidInvoices',
          await ApiFunctionCalls.filterInvoices(state.AllInvoices, 'unpaid')
        );
      } catch (error) {
        console.log(error);
      }
      try {
        commit(
          'SetPaidInvoices',
          await ApiFunctionCalls.filterInvoices(state.AllInvoices, 'paid')
        );
      } catch (error) {
        console.log(error);
      }
      // console.log('Get Invoices');
    }
  },
  async getAnnouncments({ commit, state }, locationID) {
    try {
      commit(
        'SetAnnouncments',
        await ApiFunctionCalls.getAnnouncments(locationID)
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTranslations({ commit, state }) {
    try {
      commit('SetTranslations', await ApiFunctionCalls.getTranslations());
    } catch (error) {
      console.log(error);
    }
  },
  async getPages({ commit, state }) {
    try {
      commit('SetPages', await ApiFunctionCalls.getPages());
    } catch (error) {
      console.log(error);
    }
  },
  async getEmployees({ commit, state }) {
    try {
      if (state.userRole === 'franchisee') {
        //if (state.UserData.type === 23) {
        commit('SetEmployees', await ApiFunctionCalls.getEmployees());
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getSubscriptions({ commit, state }) {
    try {
      commit('SetSubscriptions', await ApiFunctionCalls.getSubscriptions());
    } catch (error) {
      console.log(error);
    }
  },
  async getMenus({ commit, state }) {
    try {
      commit('SetSidebar', await ApiFunctionCalls.getMenu());
    } catch (error) {
      console.log(error);
    }
  },
  async getCompanyDetails({ commit, state }) {
    try {
      commit('SetCompanyDetails', await ApiFunctionCalls.getCompanyDetails());
    } catch (error) {
      console.log(error);
    }
  },
  async getUsers({ commit, state }) {
    try {
      commit('SetUsers', await ApiFunctionCalls.getUsers());
    } catch (error) {
      console.log(error);
    }
  },

  async getPostFiles({ commit, state }, postID) {
    try {
      commit('setPostFiles', await ApiFunctionCalls.getPostFiles(postID));
    } catch (error) {
      console.log(error);
    }
  },
  async getPostCats({ commit, state }) {
    try {
      commit('SET_POSTS_CATS', await ApiFunctionCalls.getPostCats());
    } catch (error) {
      console.log(error);
    }
  },
  async getFiles({ commit, state }) {
    try {
      commit(
        'SetFiles',
        await ApiFunctionCalls.formatFiles(await ApiFunctionCalls.getFiles())
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketFiles({ commit, state }) {
    try {
      commit(
        'SetTicketFiles',
        await ApiFunctionCalls.formatFiles(
          await ApiFunctionCalls.getTicketFiles()
        )
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getEvaluationReports({ commit, state }, location) {
    try {
      // if (state.UserData.type === 23) {
      commit(
        'setEvaluationReports',
        await ApiFunctionCalls.getEvaluationReports(location)
      );
      // }
    } catch (error) {
      console.log(error);
    }
  },
  async getEvaluationFiles({ commit, state }, reportID) {
    try {
      if (
        state.userRole === 'franchisee' ||
        state.userRole === 'store_manager'
      ) {
        //if (state.UserData.type === 23) {
        commit(
          'SET_EVAL_FILES',
          await ApiFunctionCalls.getEvaluationFiles(reportID)
        );
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getEvaluationReportSpecs({ commit, state }, value) {
    try {
      // if (state.UserData.type === 23) {
      commit(
        'setEvaluationReportSpecs',
        await ApiFunctionCalls.getEvaluationReportSpecs(value)
      );
      // }
    } catch (error) {
      console.log(error);
    }
  },
  async getEvaluationScore({ commit, state }) {
    try {
      if (state.UserData.type === 2 || state.UserData.type === 23) {
        commit(
          'setEvaluationScore',
          await ApiFunctionCalls.getEvaluationScore()
        );
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getEvaluationData({ commit, state }) {
    try {
      if (state.UserData.type === 2 || state.UserData.type === 23) {
        commit('setEvaluations', await ApiFunctionCalls.getEvaluationData());
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getTraineeTraining({ commit, state }) {
    try {
      commit(
        'setTraineeTraining',
        await ApiFunctionCalls.getTrainingForTrainee()
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTraineeTrainingMaterial({ commit, state }) {
    try {
      commit(
        'setTraineeTrainingMaterial',
        await ApiFunctionCalls.getTraineeTrainingMaterial()
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTraineeTrainingArchive({ commit, state }) {
    try {
      commit(
        'setTraineeTrainingArchive',
        await ApiFunctionCalls.getTraineeTrainingArchive()
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTrainingNotes({ commit, state }) {
    try {
      commit('setTrainingNotes', await ApiFunctionCalls.getTrainingNotes());
    } catch (error) {
      console.log(error);
    }
  },
  async getTrainingNotesFiles({ commit, state }) {
    try {
      commit(
        'setTrainingNotesFiles',
        await ApiFunctionCalls.getTrainingNotesFiles()
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTrainingVideos({ commit, state }) {
    try {
      commit('setTrainingVideos', await ApiFunctionCalls.getTrainingVideos());
    } catch (error) {
      console.log(error);
    }
  },
  async getWegExists({ commit, state }) {
    try {
      //if (state.userRole === 'franchisee') {
      commit('SET_WEG_EXISTS', await ApiFunctionCalls.wegExists());
      //}
    } catch (error) {
      console.log(error);
    }
  },
  async getContractorsFile({ commit, state }) {
    try {
      commit(
        'SET_CONTRACTORS_FILE',
        await ApiFunctionCalls.getExternalContractorsFile()
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getLocationExceptionsFiles({ commit, state }) {
    try {
      commit(
        'SET_LOCATION_EXCEPTIONS_FILES',
        await ApiFunctionCalls.getLocationExceptionsFiles()
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getCoverageFile({ commit, state }) {
    try {
      commit(
        'SET_IMMEDIATE_COVERAGE_PRODUCTS_FILE',
        await ApiFunctionCalls.getImmediateCoverageProducsFile()
      );
    } catch (error) {
      console.log(error);
    }
  }
};
// ------------------------------------------------ GETTERS -----------------------------------------------------------------
const getters = {
  azureUserGetter: state => state.azureUser,
  AppLoadedGetter: state => state.AppLoaded,
  bannersGetter: state => state.Banners,
  CheckListsGetter: state => state.CheckLists,
  checkListsDetailsGetter: state => state.checkListsDetails,
  clientTokenData: state => state.clientTokenData,
  currentTrainingGetter: state => state.TraineeTraining.currentTraining,
  EvaluationScoreGetter: state => state.EvaluationScore,
  EvaluationFilesGetter: state => state.EvaluationFiles,
  EvaluationsGetter: state => state.Evaluations,
  evaluationReportsGetter: state => state.evaluationReports,
  evaluationReportSpecsGetter: state => state.evaluationReportSpecs,
  examsGetter: state => state.TraineeTraining.exams,
  FranchiseStoresGetter: state => state.FranchiseStores,
  allStoresGetter: state => state.allStores,
  allJobPositionsGetter: state => state.allJobPositions,
  getMytasksData: state => state.formatedPorjectsData,
  hostname: state => state.hostname,
  informationMaterialGetter: state => state.informationMaterial,
  loggedWithAzureGetter: state => state.loggedWithAzure,
  licensesGetter: state => state.Licenses,
  knowledgeBaseGetter: state => state.knowledgeBase,
  maintenanceGetter: state => state.maintenance,
  postsGetter: state => state.Posts,
  faqsGetter: state => state.FAQPosts,
  PostFilesGetter: state => state.PostFiles,
  PostCatsGetter: state => state.PostCats,
  staffGetter: state => state.Staff,
  storeMenuGetter: state => state.StoreMenu,
  registeredDataGetter: state => state.registeredData,
  emailVerifyGetter: state => state.emailVerifyData,
  selectedLocationGetter: state => state.selectedLocation,
  selectedLocationInfoGetter: state => state.selectedLocationInfo,
  selectedWarehouseGetter: state => state.selectedWarehouse,
  tasksDataGetter: state => state.tasksData,
  trainingNotesGetter: state => state.trainingNotes,
  trainingNotesFilesGetter: state => state.trainingNotesFiles,
  TrainingVideosGetter: state => state.TrainingVide,
  traineeTrainingGetter: state => state.TraineeTraining.training,
  traineeTrainingArchiveGetter: state => state.TraineeTrainingArchive,
  traineeTrainingMaterialGetter: state => state.TraineeTrainingMaterial,
  upcomingTrainingGetter: state => state.TraineeTraining.upComingTraining,
  userTypeGetter: state => state.UserData.type,
  UserDataGetter: state => state.UserData,
  usersGetter: state => state.Users,
  userRoleGetter: state => state.userRole,
  constractorsFileGetter: state => state.ContractorsFile,
  locationExceptionsFilesGetter: state => state.LocationExceptionsFiles,
  coverageFileGetter: state => state.ImmediateCoverageProductsFile,
  userDetails: state => {
    return {
      id: state.UserData.id,
      gender: state.UserData.gender,
      f_name: state.UserData.f_name,
      l_name: state.UserData.l_name,
      phone:
        state.UserData.information && state.UserData.information.phone
          ? state.UserData.information.phone
          : '',
      phone_country_code:
        state.UserData.information &&
        state.UserData.information.phone_country_code
          ? state.UserData.information.phone_country_code
          : '',
      mobile:
        state.UserData.information && state.UserData.information.mobile
          ? state.UserData.information.mobile
          : '',
      mobile_country_code:
        state.UserData.information &&
        state.UserData.information.mobile_country_code
          ? state.UserData.information.mobile_country_code
          : '',
      email:
        state.UserData.information && state.UserData.information.email
          ? state.UserData.information.email
          : '',
      stamp_format: state.UserData.stamp_format[0],
      health_certificate_begin:
        state.UserData.c_health_certificate_begin_date &&
        state.UserData.c_health_certificate_begin_date != '0000-00-00'
          ? state.UserData.c_health_certificate_begin_date
          : '',
      health_certificate_end:
        state.UserData.c_health_certificate_exp_date &&
        state.UserData.c_health_certificate_exp_date != '0000-00-00'
          ? state.UserData.c_health_certificate_exp_date
          : '',
      birthdate:
        state.UserData.dob && state.UserData.dob != '0000-00-00'
          ? state.UserData.dob
          : '',
      consent: state.UserData.consent ? state.UserData.consent : false,
      hiringDate: state.UserData.hiring_date || '',
      clothingSize: state.UserData.clothing_size
    };
  },
  WegGetter: state => state.Weg,
  widgetsTotalsGetter: state => state.WidgetsTotal
};

// GET PROJECTS DATA & FORMAT
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/data.js